import { useCallback } from "react";
import { useStores } from "../../../stores/setup/use-store";
import { IOperationRuleAlertUser } from "../../../stores/data/insightAlerts/insightAlertModel";

interface UseAlertCreationStep2HandlersParams {
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
	setUsersTableSelected: (keys: React.Key[]) => void;
	updateTemplateValues: (templateType: string) => void;
}

export function useAlertCreationStep2Handlers({
	setFieldValue,
	setUsersTableSelected,
	updateTemplateValues,
}: UseAlertCreationStep2HandlersParams) {
	const {
		dataStores: { insightAlertStore },
	} = useStores();

	const handleTemplateTypeChange = useCallback(
		(templateType: string) => {
			setFieldValue("templateType", templateType, false);
			updateTemplateValues(templateType);
		},
		[setFieldValue, updateTemplateValues]
	);

	const handleUsersSelectionChange = useCallback(
		(selectedRowKeys: React.Key[], selectedRows: IOperationRuleAlertUser[]) => {
			setFieldValue("selectedUsers", selectedRows, false);
			setUsersTableSelected(selectedRowKeys);
			insightAlertStore.setOperationRuleAlertUserSelected(selectedRows);
		},
		[setFieldValue, insightAlertStore, setUsersTableSelected]
	);

	return {
		handleTemplateTypeChange,
		handleUsersSelectionChange,
	};
}
